import * as R from 'ramda';

const propIsTruthy = R.curry((prop, data) => R.compose(Boolean, R.prop(prop))(data));

export default propIsTruthy;
